export default __webpack_public_path__ + "static/media/referral-claim@2x.71761b4a.png";